import Stream from 'mithril/stream';
export default Stream;
flarum.reg.add('core', 'common/utils/Stream', Stream);